import { adminSupabase, supabase } from '@/lib/supabase'
import { releasesApi } from '@/api/releases'
import type { ManualPrepared, ManualState } from '@/lib/manualSqlReview'
import { manualSqlFailure, verifyManualReply, type ManualSqlOperation } from '@/lib/manualSqlTransport'
async function call<T>(operation: ManualSqlOperation, body: Record<string,unknown>): Promise<T> {
  if (releasesApi.workflowReadOnly) throw Error('תצוגה לקריאה בלבד — אישורי בעלים אינם זמינים כאן.')
  const {data:{session}}=await supabase.auth.getSession()
  if (!session?.access_token) throw Error('נדרשת התחברות מחדש')
  let response
  try { response=await adminSupabase.functions.invoke('release-ops',{body,headers:{Authorization:`Bearer ${session.access_token}`}}) }
  catch { throw manualSqlFailure(null,body.request_id as string|undefined) }
  const {data,error}=response
  if(error) {
    const context=(error as {context?:Response}).context
    const failure=context?await context.json().catch(()=>null):null
    throw manualSqlFailure(failure,body.request_id as string|undefined)
  }
  return verifyManualReply(operation,data,body) as T
}
export const manualSqlApi={
  prepare:(pr_number:number)=>call<ManualPrepared>('prepare',{action:'admin_manual_sql_prepare',pr_number}),
  approve:(input:{pr_number:number;expected_head:string;fingerprint:string;request_id:string;reason:string})=>call<{approval_id:string}>('approve',{action:'admin_manual_sql_approve',...input}),
  state:(request_id:string)=>call<ManualState & {found:boolean}>('state',{action:'admin_manual_sql_state',request_id}),
}
